import React, { useCallback } from 'react';
import { FileParams, theme } from '@zonofi/common';
import { downloadFile } from '@zonofi/seller-hub/helper/download-file';
import { dispatch, showToast, ErrorVariants } from '@zonofi/zono-money-store';
import { MediaAction, useHandleMediaDownload } from './handle-media-download';
import { ReactComponent as DownloadIcon } from '@zonofi/svg-icons/download.svg';
import { ReactComponent as FileIcon } from '@zonofi/svg-icons/file-new.svg';

export const DocumentView: React.FC<FileParams> = (props) => {
  const { filename = '', link, generateLinkParams } = props;
  const ext = filename.slice(filename.lastIndexOf('.') + 1).toUpperCase();

  const onError = useCallback(() => {
    dispatch(
      showToast({
        canDisplay: true,
        message: 'Error downloading media',
        responseStatus: 'Error',
        type: ErrorVariants.DANGER,
      })
    );
  }, []);

  const onSuccess = useCallback(
    async (url: string, action: MediaAction) => {
      try {
        switch (action) {
          case 'open':
            window.open(url, '_blank');
            break;

          case 'download':
            downloadFile({ url, fileName: filename });
            break;

          case 'render':
            break;

          default:
            console.warn(`Unhandled media action: ${action}`);
        }
      } catch (err) {
        console.error(`Error in onSuccess (${action}):`, err);
        onError();
      }
    },
    [downloadFile, filename, onError]
  );

  const { getMedia, isLoading } = useHandleMediaDownload({
    onSuccess,
    onError,
    filename,
    link,
  });

  const openFile = async () => {
    await getMedia(generateLinkParams, 'open');
  };

  const download = async (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    await getMedia(generateLinkParams, 'download');
  };

  return (
    <div
      className="chat-flexRowAlCenterJcSpaceBetn document-view"
      style={{ borderColor: `${theme.text.secondary}80` }}
      onClick={openFile}
    >
      <div className="file-container">
        <FileIcon height={18} />
        <div className="doc-container">
          <div className="document-title font-semibold">{filename}</div>
          <div className="font-regular document-ext">{ext}</div>
        </div>
      </div>
      {isLoading ? (
        <div />
      ) : (
        <div onClick={download}>
          <DownloadIcon color="#363636" />
        </div>
      )}
    </div>
  );
};
